import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH} from '../../configs/const';

export default class CasinoCurrencyModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        
    }

    render() {

        return (
            <>
                <div id="marketbetspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered encasino">
                        <div className="modal-content">
                            <div className="modal-body engcasinomodalbgimg">
                                
                            <button onClick={() => { this.props.hidePopup() }} type="button" className="close text-white ecasinobtnclose" data-dismiss="modal" aria-hidden="true">×</button>
                                    <img alt="" src={`${BASE_IMAGE_PATH}/casino/banner/images/${this.props.fileNM}${this.props.currencyEquals}.webp`} className="img-fluid" />
                                <button type="button" className='virtual-close-btn' onClick={() => { this.props.hidePopup() }} data-dismiss="modal">&nbsp;</button>

                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" onClick={() => { }}></div>
                </div>
            </>
        )
    }
}
